// `GET /api/auth-options` (J-257): whether this server can mail a password-reset link. Production has no
// mail transport, so there "Forgot password?" is not offered and the reset page says to ask an
// administrator. Public and the same for everyone: no session, no PHI.
import { type QueryClient, queryOptions } from "@tanstack/react-query";
import { AUTH_OPTIONS_PATH, type AuthOptions } from "@vbltc/schema";
import { fetchClient } from "@/api/client";

/** The words for a server with no mail transport; the server's refusal says the same. */
export const RESET_UNAVAILABLE_MESSAGE =
  "Password reset by email is not available here. Ask an administrator to reset your password.";

const authOptionsQueryOptions = () =>
  queryOptions({
    queryKey: ["auth", "options"],
    queryFn: async (): Promise<AuthOptions> => {
      const { data } = await fetchClient.GET(AUTH_OPTIONS_PATH);
      if (data === undefined) throw new Error("auth options unavailable");
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });

/**
 * The options for a route loader, or null when the read failed. The sign-in page clears the query cache
 * when it opens (J-243), so a page reads the answer from its loader data, not from a cached query.
 */
export const loadAuthOptions = (queryClient: QueryClient): Promise<AuthOptions | null> =>
  queryClient.fetchQuery(authOptionsQueryOptions()).catch(() => null);
